import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../footer";
import RegisterVisual from "../Visual/registerVisual";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Award } from "../../Api/Database";
import config from "../../Api/config";
import { useSession } from "../sessionProvider";

type FormInputs = {
    file: FileList,
};

function RegisterProduct(props: any) {


    const navigate = useNavigate();
    const notifyError = (err: any) => toast.error(err, { theme: "colored" });
    const notifySuccess = (text: any) => toast.success(text, { theme: "colored" });

    const { handleSubmit, formState: { errors } } = useForm<FormInputs>();

    const { ownerId } = useSession();
    const { productId } = useParams();

    const [productData, setProductData] = useState({
        title: "",
        description: "",
        video_url: "",
        thumbnail: "",
        image_gallery: [] as string[],
        sap_product_code: "",
        shop_url: "",
    });

    const [userManualData, setUserManualData] = useState({
        "product_presentation": "",
        "video_presentation": "",
        "user_manual": "",
        "cleaning_instructions": ""
    });

    const [sustainabilityData, setSustainabilityData] = useState({
        "recycled_biobased_material_share": "",
        "energy_source_in_production": "",
        "recyclability": "",
        "compliance_with_standards": "",
        "carbon_footprint": "",
        "carbon_footprint_reduction_renewables": ""
    });

    const [awards, setAwards] = useState<Award[]>([]);

    useEffect(() => {
        if (productId) {
            config.API.getProduct(productId).then(product => {
                setProductData({
                    title: !props.createVariant ? product.title : "",
                    description: product.description,
                    thumbnail: product.thumbnail,
                    image_gallery: product.image_gallery,
                    sap_product_code: (!props.createVariant ? product.sap_product_code : ""),
                    video_url: product.video_url,
                    shop_url: product.shop_url,
                });
                setSustainabilityData(product.sustainability);
                setUserManualData(product.user_manual);
                setAwards(product.awards);
            }).catch(error => {
                console.error("Error in get product API: ", error);
                notifyError("Error in get product API: " + error);
            });
        }
    }, [])

    const changeProductData = (name: string, data: any): void => {

        setProductData({ ...productData, [name]: data });
    };

    /*const changeManualData = (name: string, data: any): void => {
        setUserManualData({ ...userManualData, [name]: data });
    };
    const changeSustainabilityData = (name: string, data: any): void => {
        setSustainabilityData({ ...sustainabilityData, [name]: data });
    };*/

    const onSubmitForm: SubmitHandler<FormInputs> = (data: FormInputs) => {

        let newLink = productData.video_url;
        // Check if youtube video is valid
        if (productData.video_url !== '') {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            var match = productData.video_url.match(regExp);


            if (match && match[2].length == 11) {
                newLink = 'https://www.youtube.com/embed/' + match[2];
            } else {
                // vrni error
                notifyError("Error: Invalid youtube link. Make sure video link is enbeded.");
                return
            }

            //https://www.youtube.com/watch?v=5gg17XXXiNo
        }

        // edit product 
        if (productId && !props.createVariant) {
            config.API.editProduct(ownerId, productId, {
                ...productData, sustainability: sustainabilityData, user_manual: userManualData, awards: awards, video_url: newLink,
            }).then((value) => {
                navigate('/products')
                notifySuccess("Updated product '" + productData.title + "'.");
            }).catch(error => {
                console.error("Error in API Issue: ", error);
                notifyError("Error in onboarding API: " + error);
            });
        } else { // creating product
            config.API.addProduct(ownerId, {
                ...productData, sustainability: sustainabilityData, user_manual: userManualData, awards: awards, video_url: newLink,
            }).then((value) => {
                notifySuccess("Registered product '" + productData.title + "'.");
                navigate("/register/variant/" + value)

            }).catch(error => {
                console.error("Error in API Issue: ", error);
                notifyError("Error in onboarding API: " + error);
            });
        }
    }

    return (<>
        <div className="company">

            <RegisterVisual title={(productId && !props.createVariant) ? "Edit product " + productData.title : "Register new product"} />

            <div className="explorer">

                <form className="form" onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    handleSubmit(onSubmitForm)(event);
                }} >

                    <div>
                        <label> <span className="requiredMark">*</span> Product title{" "} </label>
                        <input type="text" className="issuer-form" name="title" maxLength={400} placeholder="e.g., Product 1" value={productData.title} onChange={(event) => { changeProductData("title", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Description {" "} </label>
                        <input type="text" className="issuer-form" name="description" maxLength={1000} placeholder="e.g., The product can be purchased in several colors." value={productData.description} onChange={(event) => { changeProductData("description", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Thumbnail {" "} </label>
                        <input type="url" className="issuer-form" name="thumbnail" maxLength={1000} placeholder="e.g., https://www.example.com/logo.png" value={productData.thumbnail} onChange={(event) => { changeProductData("thumbnail", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> Video (embeded) {" "} </label>
                        <input type="url" className="issuer-form" name="video_url" maxLength={1000} placeholder="e.g., https://www.youtube.com/" value={productData.video_url} onChange={(event) => { changeProductData("video_url", event.target.value); }} ></input>
                    </div>

                    <button className="btn btn-primary" type="submit"> {(productId && !props.createVariant) ? 'Save changes' : 'Register product'}</button>
                    <button className="btn btn-secondary" onClick={() => {
                        navigate('/products');
                    }} > Back</button>
                </form>

            </div>

            <Footer />
        </div>
    </>)
}

export default RegisterProduct;
